import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import {inject} from '@angular/core';
import {LocalStorageService} from '../services/localStorage/local-storage.service';
import {catchError, throwError} from 'rxjs';
import {Router} from '@angular/router';
import { ToastService } from '../services/toast/toast.service';

export const appHttpInterceptor: HttpInterceptorFn = (req, next) => {

  const localStorage: LocalStorageService = inject(LocalStorageService);
  const router: Router = inject(Router);
  const toastService: ToastService = inject(ToastService);

  const token = localStorage.getToken(); // Récupérer le token
  let authReq = req;
  if (token) {
    authReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`)
    });
  }

  const clubId = localStorage.getClubId();
  if (clubId && ['POST', 'PUT', 'PATCH'].includes(authReq.method) && authReq.body && typeof authReq.body === 'object' && !Array.isArray(authReq.body) && !(authReq.body instanceof FormData)) {
    const newBody = { ...authReq.body as any };
    
    if (newBody.__skipClub) {
      // Remove the flag so it isn't sent to the backend
      delete newBody.__skipClub;
      authReq = authReq.clone({ body: newBody });
    } else {
      // Inject club if not present
      if (newBody.club === undefined && newBody.club_id === undefined) {
        newBody.club = clubId;
      }
      authReq = authReq.clone({ body: newBody });
    }
  }

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        toastService.showToast('Session expirée', true);
        localStorage.clearAll();
        router.navigate(['/auth']);
      }
      return throwError(() => error);
    })
  );
};
